import { render, staticRenderFns } from "./LabelCornerTopRightIcon.vue?vue&type=template&id=7840c18f&"
import script from "./LabelCornerTopRightIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCornerTopRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports